import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import { spacing } from 'styles/constants';

export const MenuObjectSkeleton = () => (
  <Box>
    <Box style={styles.heroSkeletonWrapper}>
      <Skeleton h="$72" w="full" mb="$3" rounded="4" mx="auto" />
    </Box>
    <Box style={styles.content}>
      <Skeleton h="$6" rounded="full" mb="$8" />
      <Skeleton h="$4" rounded="full" mb="$8" width="40%" mx="auto" />
      <Skeleton h="$4" rounded="full" mb="$8" width="30%" />
      <Skeleton.Text lines={2} mb="$8" />
      <Skeleton.Text lines={2} mb="$8" />
      <Skeleton.Text lines={8} mb="$8" />
    </Box>
  </Box>
);

const styles = StyleSheet.create({
  content: {
    padding: spacing.$4,
  },
  heroSkeletonWrapper: {
    marginBottom: spacing.$4,
  },
});
